import { BackendHttpService } from "../../../services/backendHttpService";
import { EmployeeListFilter, EmployeeOverviewPage } from "../models/employeeOverview.model";

export interface GetEmployeeOverviewPageRequest {
    filter: EmployeeListFilter;
}

export interface BulkSetEmployeeAvailabilityDateRequest {
    employeeIds: number[];
    /** Undefined/null clears availability for every employee in the selection. */
    availabilityDate?: string;
}

class EmployeeOverviewService extends BackendHttpService {
    constructor() {
        super("api/employee-management");
    }

    getPage(request: GetEmployeeOverviewPageRequest): Promise<EmployeeOverviewPage> {
        return this.post<GetEmployeeOverviewPageRequest, EmployeeOverviewPage>(request, "/get-page");
    }

    bulkSetAvailabilityDate(request: BulkSetEmployeeAvailabilityDateRequest): Promise<void> {
        return this.post<BulkSetEmployeeAvailabilityDateRequest, void>(request, "/bulk-set-availability");
    }
}

export const employeeOverviewService = new EmployeeOverviewService();
